// extracted by mini-css-extract-plugin
var _1 = "PhaseStripItem-modulePhaseStripItem__qwtaA";
var _2 = "PhaseStripItem-modulecontent__UWm2M";
var _3 = "PhaseStripItem-modulecontentNeedsYou__KHCoI";
var _4 = "PhaseStripItem-modulelabel__wlPWi";
var _5 = "PhaseStripItem-modulemarker__mJMWM";
var _6 = "PhaseStripItem-modulemarkerDone__B84DI";
var _7 = "PhaseStripItem-modulemarkerNeedsYou___3rz2";
var _8 = "PhaseStripItem-modulemeta__ZXFCa";
var _9 = "PhaseStripItem-moduleneedsYou__yKb1p";
var _a = "PhaseStripItem-moduleneedsYouDot__A80yX";
export { _1 as "PhaseStripItem", _2 as "content", _3 as "contentNeedsYou", _4 as "label", _5 as "marker", _6 as "markerDone", _7 as "markerNeedsYou", _8 as "meta", _9 as "needsYou", _a as "needsYouDot" }
